import { useContext } from "react";
import { GlobalContext } from "store/globalContext";

export const LocationsDescription = () => {
  const {
    userData: { locations },
  } = useContext(GlobalContext);

  if (!locations?.length) {
    return null;
  }

  return (
    <div className="ml-4 mt-3 text-sm text-gray-700 font-bold">
      <span className=" text-gray-500 font-normal">Your locations include</span>{" "}
      {locations?.map(({ name }) => name).join(", ")}
      <span className=" text-gray-500 font-normal">
        {locations.length === 1 ? "" : ","} and the default location.
      </span>{" "}
    </div>
  );
};
